<template lang="pug">
.profile-edit
  v-card
    v-card-title 新增用戶
    v-card-text
      v-form(
        ref="form"
        v-model="valid"
        lazy-validation)
        v-container
          v-layout
            v-flex(
              xs12
              m4)
              v-text-field(
                v-model="firstName"
                :rules="firstNameRules"
                :counter="2"
                label="姓"
                required)
            v-flex(
              xs12
              m4)
              v-text-field(
                v-model="lastName"
                :rules="lastNameRules"
                :counter="2"
                label="名"
                required)
            v-flex(
              xs12
              m4)
              v-select(
                v-model="gender"
                :rules="genderRules"
                :items="genderItems"
                item-value="value"
                item-text="text"
                label="性別"
                required)
          v-layout
            v-flex.caption.error--text(xs12)
              span {{ message }}
    v-card-actions
      v-btn(
        :loading="loading"
        @click="submit") 送出
</template>

<script>
import { mapGetters } from "vuex";
import { functions } from "@/firebase";
import { required, email, maxLen } from "@/utils/validators";
import regionItems from "@/assets/data/regions.json";
import roleItems from "@/assets/data/roles.json";

export default {
  name: "ProfileEdit",
  data() {
    return {
      valid: null,
      firstName: null,
      firstNameRules: [required("此為必填欄位"), maxLen(2, "最多兩個中文字")],
      lastName: null,
      lastNameRules: [required("此為必填欄位"), maxLen(2, "最多兩個中文字")],
      gender: null,
      genderRules: [],
      genderItems: [
        { value: "male", text: "男" },
        { value: "female", text: "女" }
      ],
      loading: false,
      message: ""
    };
  },
  computed: {
    ...mapGetters(["apiConf"])
  },
  methods: {
    async submit() {
      const {
        email,
        password,
        gender,
        region,
        firstName,
        lastName,
        role,
        manageRegion
      } = this;

      try {
        const res = await this.$http.post(
          "/user",
          {
            email,
            password,
            gender,
            region,
            firstName,
            lastName,
            role,
            manageRegion
          },
          this.apiConf
        );
      } catch (e) {
        console.log(e);
        this.message = e.response.data.message;
      }
    }
  }
};
</script>
